<template>
  <div style="overflow: hidden; display: block; height: calc(100% - 0.5rem)">
    <div class="SL_offerMaterialListView">
      <img :src="message.showImage" @click="goParticulars" />
      <!-- 默认展示 -->
      <div class="SL_offerMaterialList_B">
        <div class="SL_offerMaterialList_B_user">
          <img src="../assets/logo.png" />
          {{ message.createUserName }}
        </div>
        <div class="SL_offerMaterialList_B_uimgList">
          <img style="margin-right: 0.16rem" @click="isSouCang" :src="list.isCollect == 0
              ? require('../assets/publick_shoucang.png')
              : require('../assets/publick_shoucangOk.png')
            " />

          <img @click="addShopping" src="../assets/publick_gouwuche.png" />
        </div>
      </div>
      <div class="SL_offerMaterialList_C">
        <span class="LSC_title">{{ message.title }}</span>
        <span class="LSC_time">{{ message.playTime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { Axios } from "../assets/js/ls_com_axios.js";
const router = useRouter();

const newData = defineProps({
  message: {
    type: Object, //类型字符串
  },
});
let list = ref({
  isCollect: "0",
});
// 获取素材详情
let get_sucai_number_xq = function () {
  Axios(
    "get",
    "/fodder/info/" + newData.message.materialId,
    false,
    false,
    function (res) {
      console.log("res", res);
      list.value = res.data.data;
    }
  );
};
if (newData.message) {
  get_sucai_number_xq();
}
// 跳转详情页
let goParticulars = function () {
  console.log("newData.message.materialId", newData.message);
  router.push({
    path: "/ShadowMaterialVideoParticulars",
    query: {
      id: newData.message.materialId,
    },
  });
};
// 获取详细信息
// let setSuCaiList = function () {
//   Axios(
//     "get",
//     "/fodder/info",
//     { materialId: newData.message.materialId },
//     false,
//     function () {}
//   );
// };
//收藏按钮
let isSouCang = function () {
  console.log(list.value);
  if (list.value.isCollect == 0) {
    // 收藏
    Axios(
      "post",
      "/fodder/collect",
      { materialId: list.value.id },
      false,
      function (res) {
        get_sucai_number_xq();
        ElMessage({
          showClose: true,
          message: "收藏成功",
          type: "success",
        });
      }
    );
  } else {
    //	取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      { materialId: list.value.id },
      false,
      function (res) {
        get_sucai_number_xq();
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
      }
    );
  }
};
//加入购物车
let addShopping = function () {
  Axios(
    "POST",
    "/fodder/car",
    { materialId: list.value.id },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
</script>

<style scoped>
.SL_offerMaterialListView {
  overflow: hidden;
  border-radius: 0.1rem;
  position: relative;
  height: 1.8rem;
}

.SL_offerMaterialListView:hover .SL_offerMaterialList_B {
  bottom: 0rem;
}

.SL_offerMaterialListView:hover .SL_offerMaterialList_C {
  bottom: -0.6rem;
}

.SL_offerMaterialListView>img {
  width: 100%;
  display: block;
  overflow: hidden;
  border-radius: 0.12rem;
  height: calc(100%);
}

.SL_offerMaterialList_A {
  padding: 0.12rem 0.16rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_A>span {
  color: #fff;
  font-size: 0.12rem;
}

.SL_offerMaterialList_B {
  padding: 0.12rem 0.08rem;
  position: absolute;
  bottom: 0rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  transition: bottom 0.5s;
}

/* .SL_offerMaterialList_B:hover{
	bottom: -0.6rem;
} */

.SL_offerMaterialList_B,
.SL_offerMaterialList_C {
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_C {
  padding: 0.12rem 0.16rem;
  background: linear-gradient(180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%);
  bottom: 0rem;
  transition: bottom 0.5s;
}

.SL_offerMaterialList_B_user,
.SL_offerMaterialList_B_imgList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_B_user {
  padding: 0.04rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.25);
  font-size: 0.12rem;
  color: #fff;
}

.SL_offerMaterialList_B_user>img {
  width: 0.24rem;
}

.SL_offerMaterialList_B_uimgList>img {
  width: 0.32rem;
}

.SL_offerMaterialList_C {
  font-size: 0.12rem;
  color: #ffffff;
}
</style>
